<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication">To Peter Conrad</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fussell_Muscle_4P_MD2.vue?b1d9d6f6